export function preventFormSubmitOnTooltipClick() {
  let tooltipButton = document.getElementsByClassName('ppvx_tooltip__icon');
  Object.values(tooltipButton).map((btn) => {
    btn.type = 'button';
  });
}
